import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("../views/error-page/404"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("../views/dashboard/index"),
        name: "Dashboard",
        meta: {
          title: "Dashboard",
          icon: "dashboard"
        }
      }
    ]
  },
  {
    path: "/loginfo",
    component: Layout,
    redirect: "/loginfo/ds",
    name: "Loginfo",
    meta: {
      title: "应用索引",
      icon: "log"
    },
    children: [
      {
        path: "ds",
        component: () => import("../views/loginfo/ds"),
        name: "DS",
        meta: {
          title: "DS日志",
          icon: "ds"
        }
      },
      {
        path: "lib",
        component: () => import("../views/loginfo/lib"),
        name: "Lib",
        meta: {
          title: "图书馆日志",
          icon: "lib"
        }
      },
      // TODO: 修改名称
      {
        path: "air",
        component: () => import("../views/loginfo/air"),
        name: "Air",
        meta: {
          title: "中文在线日志",
          icon: "air"
        }
      },
      {
        path: "idp",
        component: () => import("../views/loginfo/idp"),
        name: "Idp",
        meta: {
          title: "IDP日志",
          icon: "idp"
        }
      }
    ]
  },
  // {
  //   path: "/xml",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("../views/xmlinfo"),
  //       name: "XML",
  //       meta: {
  //         title: "XML日志",
  //         icon: "XML"
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: "/snmp",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("../views/snmp"),
  //       name: "SNMP",
  //       meta: {
  //         title: "SNMP日志",
  //         icon: "snmp"
  //       }
  //     }
  //   ]
  // },
  {
    path: "/devops",
    component: Layout,
    meta: {
      title: "运维支持",
      icon: "devops"
    },
    children: [
      {
        path: "sys",
        component: () => import("../views/devops/sys"),
        name: "sys",
        meta: {
          title: "服务器情况",
          icon: "sys"
        }
      },
      {
        path: "searchip",
        component: () => import("../views/devops/searchip"),
        name: "searchip",
        meta: {
          title: "IP搜索",
          icon: "searchip"
        }
      },
      {
        path: "suspiciousip",
        component: () => import("../views/devops/suspiciousip"),
        name: "suspiciousip",
        meta: {
          title: "可疑IP",
          icon: "suspiciousip"
        }
      },
      {
        path: "searchres",
        component: () => import("@/views/devops/searchres"),
        name: "searchres",
        hidden: true
      },
      {
        path: "dns",
        component: () => import("@/views/devops/dns"),
        name: "dns",
        meta: {
          title: "DNS请求情况",
          icon: "dns"
        }
      },
      // {
      //   path: "auth",
      //   component: () => import("@/views/devops/auth"),
      //   name: "auth",
      //   meta: {
      //     title: "SSH请求情况",
      //     icon: "auth"
      //   }
      // }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const router = new VueRouter({
  routes
});

export default router;
